import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/animations/ScrollMorphMedia.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceCard"] */ "/vercel/path0/app/components/ui/service-card.tsx");
